module.exports = __webpack_public_path__ + "static/portillo_top_image_thumbnail-195dfe63f8f0be8a8f1e15b18335656c.png";